module.exports = __webpack_public_path__ + "static/media/banner-slide.e0d86df7.png";